import { state } from '../core/state.mjs';
import { CONFIG } from '../core/config.mjs';

/**
 * Initialise lazy loading avec IntersectionObserver
 */

export function lazyLoading() {
    // Fallback sans IntersectionObserver
    if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('img.lazy-image').forEach(img => {
            img.srcset = img.getAttribute('data-srcset');
            img.src = img.getAttribute('data-src');
        });
        return;
    }

    if (state.observer) state.observer.disconnect();

    state.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                const tempImg = new Image();
                const srcset = img.getAttribute('data-srcset');
                const src = img.getAttribute('data-src');

                tempImg.onload = function () {
                    img.srcset = srcset;
                    img.src = src;
                    img.classList.remove('lazy-image');
                    img.classList.add('ai-loaded');
                    state.observer.unobserve(img);
                };

                tempImg.onerror = function () {
                    img.srcset = srcset;
                    img.src = src;
                    img.classList.remove('lazy-image');
                    img.classList.add('ai-loaded');
                    state.observer.unobserve(img);
                    console.warn(`[AI] Erreur: ${src}`);
                };

                tempImg.srcset = srcset;
                tempImg.src = src;
            }
        });
    }, {
        rootMargin: CONFIG.lazyLoading.rootMargin,
        threshold: CONFIG.lazyLoading.threshold
    });

    document.querySelectorAll('img.lazy-image').forEach(img => {
        state.observer.observe(img);
    });
}
